import supabase from "@/services/supabaseClient.js";

const PROFILE_KIND_BY_ROLE = {
  doctor: "doctor",
  patient: "patient",
};

function normalizeProfileKind(role = "patient") {
  const normalized = String(role || "patient").trim().toLowerCase();
  return PROFILE_KIND_BY_ROLE[normalized] || "patient";
}

function normalizePatch(patch = {}) {
  const next = patch && typeof patch === "object" ? patch : {};
  const allowed = {};
  if (next.appointment_reminders && typeof next.appointment_reminders === "object") {
    allowed.appointment_reminders = next.appointment_reminders;
  }
  if (next.device_alerts && typeof next.device_alerts === "object") {
    allowed.device_alerts = next.device_alerts;
  }
  return allowed;
}

// One database boundary for explicit notification preference intent. The RPC
// performs the revision check and merges just the requested canonical section.
export async function patchOwnNotificationPreferences({
  role = "patient",
  expectedUpdatedAt = null,
  patch = {},
  source = "notification_settings",
  onlyIfAppointmentReminderMissing = false,
} = {}) {
  const cleanPatch = normalizePatch(patch);
  if (Object.keys(cleanPatch).length === 0) {
    return { data: null, error: new Error("notification_preference_patch_required") };
  }

  const { data, error } = await supabase.rpc("patch_my_notification_preferences", {
    p_profile_kind: normalizeProfileKind(role),
    p_expected_updated_at: expectedUpdatedAt || null,
    p_patch: cleanPatch,
    p_source: String(source || "notification_settings"),
    p_only_if_appointment_reminder_missing: Boolean(onlyIfAppointmentReminderMissing),
  });

  const row = Array.isArray(data) ? data[0] || null : data || null;
  return { data: row, error };
}
